module.exports = __webpack_public_path__ + "static/media/chart.bb8d765e.png";